import BadgesComponent from '@components/common/Badges';
import './index.css';
import React, { useEffect, useState } from 'react';
import CheckboxComponent from '@components/common/CheckBox';
import Button from '@components/common/Button';
import ReAuthenticateConfirmationModal from '../../CreateBeneficiary/FaceAuthentication/ReAuthenticateConfirmationModal';
import ReAuthenticationModal from '../../CreateBeneficiary/FaceAuthentication/ReAuthenticationModal';
import VerificationModal from '../../CreateBeneficiary/VerificationModal';
import FaceAuthenticationModal from '../../CreateBeneficiary/FaceAuthenticationModal';
import { getData, postDataJSON, putDataJSON } from '../../../../services/CommonApiService';
import endpoints from '@config/endpoints';
import { useParams } from 'react-router-dom';
import {
  setBeneficiaryDetails,
  setBenfDeathDetails,
  updateDeliveryDetails,
} from '@store/actions/beneficiaryAction';
import { useDispatch, useSelector } from 'react-redux';
import { calculateCompletedWeeksPregnancy } from '@utils/hrpConditionCheck';
import dayjs from 'dayjs';
import { errorLogger } from '@utils/applicationLogUtils';
import Unauthorised from '@components/Auth/Unauthorised';
import { dateFormate } from '@constants/index';
import { gender } from '@utils/commonUtils';
import { desiredFormatDate } from '@utils/commonUtils';
import { RootState } from '@store/reducers';
import { setBeneficiaryRedgOption, setBeneficiaryAuthType, setBeneficiaryGender } from '@store/actions/beneficiaryAction';
import { benef_const } from '@constants/beneficiaryConstant';
import { toast } from 'react-toastify';
import { encodeWithKeyAndShift } from '@utils/base64Utils';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { buttonNames, REGEX_PATTERNS } from '@constants/appConstants';
import config from '@config/config';
 
const BeneficiaryView = ({beneficiaryViewProp}: {beneficiaryViewProp: any})  => {
  const {pregnancyDetails, pregnancyHistoryDetails, beneficiaryDetails, obstetricHistoryData} = beneficiaryViewProp;
  const [beneficiaryData, setBeneficiaryData] = useState<any>();
  const[benefDeathDetails,setBenefDeathDetails] = useState<any>([]);
  const [showUnauthorized, setShowUnauthorized] = useState<boolean>(false);
  const [historyData, setHistoryData] = useState<any>(obstetricHistoryData || []);
  const [showReAuthModal, setShowReAuthModal] = useState<boolean>(false);
  const [showVerificationModal, setShowVerificationModal] = useState<boolean>(false);
  const [showFaceAuthModal, setShowFaceAuthModal] = useState<boolean>(false);
  const [showComparisonModal, setShowComparisonModal] = useState<boolean>(false);
  const [linkedBenefDetails, setLinkedBenefDetails] = useState<string>('');
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isReAuthFlow, setIsReAuthFlow] = useState<boolean>(false);
  const [abdmData, setAbdmData] = useState<any>(null);
  const benfDetails = useSelector(
    (state: RootState) => state.beneficiary.beneficiaryDetails,
  );
  const [completedWeeksPregnancy, setCompletedWeeksPregnancy] =
    useState<any>(0);
 
  const { id } = useParams();

  useEffect(() => {
    setHistoryData(obstetricHistoryData || []);
  }, [obstetricHistoryData]);

  useEffect(() => {
    const fetchData = async () => {
     const storeData:any={};
     storeData.data=benfDetails;
      const response =benfDetails?.length>0 ?storeData : beneficiaryDetails
      if(!response?.data || response.data.length === 0){
        setShowUnauthorized(true);
      }
      else{
      setShowUnauthorized(false);
      setBeneficiaryData(response?.data[0]);
      dispatch(setBeneficiaryDetails(response?.data));
      dispatch(updateDeliveryDetails('parentAbha', response?.data[0]?.abha_id));
      setBenefDeathDetails(response?.data);
      dispatch(setBenfDeathDetails(response.data));
      }
     };
    (beneficiaryDetails?.data?.length>0 || benfDetails?.length>0) && fetchData();
  }, [benfDetails]);
  const dispatch = useDispatch();
  const isVerified = beneficiaryData?.abha_id;




  const getPregnancyHistory = async () => {
    try {
      const onGoingPregnancy = pregnancyHistoryDetails?.data?.find(
        (data: any) => data?.delivery_status === 'on going',
      );
      if (onGoingPregnancy && onGoingPregnancy?.delivery_status === 'on going') {
        const ongoingPregnancyDetails=pregnancyDetails;
        const pregnancyWeeks =ongoingPregnancyDetails[0]?.lmp && await calculateCompletedWeeksPregnancy(ongoingPregnancyDetails[0]?.lmp)||0;
        setCompletedWeeksPregnancy(pregnancyWeeks);
      }
    } catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error)
    }
  };
 
  useEffect(() => {
    pregnancyHistoryDetails && getPregnancyHistory();
  }, [pregnancyHistoryDetails]);

  const compareData = (rchData: any, abdmData: any) => {
    const formatDate = (dateValue: string) => {
      if (!dateValue) return '';
      
      if (REGEX_PATTERNS.DATE_DD_MM_YYYY.test(dateValue)) {
        return dateValue;
      }
      
      const date = new Date(dateValue);
      if (!isNaN(date.getTime())) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
      
      return dateValue;
    };

    
    const rchDob = formatDate(rchData?.dob);
    const abdmDob = formatDate(abdmData?.dob);
    
    const rchAbhaId = rchData?.abha_id?.replace(/-/g, '') || '';
    const abdmAbhaId = abdmData?.abhaId?.replace(/-/g, '') || '';
    
    const rchName = (rchData?.benf_name || '').trim();
    const abdmName = (abdmData?.name || '').trim();
    
    return {
      nameMatch: rchName === abdmName,
      dobMatch: rchDob === abdmDob,
      abhaIdMatch: rchAbhaId === abdmAbhaId,
      allMatch: rchName === abdmName && rchDob === abdmDob && rchAbhaId === abdmAbhaId
    };
  };

  const updateBeneficiaryWithFaceAuth = async (abdmData: any, updateAllFields: boolean = false) => {
    try {
      const loggedInUserId = localStorage.getItem('userId');
      const benfMigratedLocalStorage: any = localStorage.getItem('isBenfMigrated')?.split(" ");
      const isBenfMigratedLocalStorage = benfMigratedLocalStorage?.[0] === 'true' ? true : false;
      
      const payload: any = {
        benefId: beneficiaryData?.benef_id,
        isFaceAuthenticated: true,
        parentUserId: loggedInUserId,
        parentUserTypeId: null,
        parentRoleId: null,
        genderId: beneficiaryData?.gender_id,
        primaryMob: beneficiaryData?.mob,
        spouseName: beneficiaryData?.spouse_name,
        religionId: beneficiaryData?.religion_id,
        otherReligion: beneficiaryData?.other_religion,
        categoryId: beneficiaryData?.category_id,
        alternateMob: beneficiaryData?.alternate_mob,
        healthProviderId: beneficiaryData?.healthprovider_id?.length > 0 ? beneficiaryData?.healthprovider_id : [],
        mobiliserId: beneficiaryData?.mobiliser_id?.length > 0 ? beneficiaryData?.mobiliser_id : [],
        is_mobiliser_changed: false,
        is_healthprovider_changed: false,
        isPvtgClassified: beneficiaryData?.is_pvtg_classified,
        enrollForSms: beneficiaryData?.enroll_for_sms,
        effectiveFromDt: null,
        wardId: beneficiaryData?.ward_id,
        villageId: beneficiaryData?.village_id,
        facilityId: beneficiaryData?.facility_id?.length > 0 ? beneficiaryData?.facility_id[0] : null,
        isBenfMigrated: isBenfMigratedLocalStorage,
        consentTemplateDetails: null
      };

      if (updateAllFields) {
        let formattedDob = abdmData?.dob;
        
        if (REGEX_PATTERNS.DATE_DD_MM_YYYY.test(abdmData?.dob)) {
          const [day, month, year] = abdmData.dob.split('-');
          formattedDob = `${year}-${month}-${day}`;
        } else if (abdmData?.dob) {
          const date = new Date(abdmData.dob);
          if (!isNaN(date.getTime())) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            formattedDob = `${year}-${month}-${day}`;
          }
        }
        payload.beneficiaryName = abdmData?.name;
        payload.beneficiaryDob = formattedDob;
        payload.abhaId = beneficiaryData?.abha_id?.replace(/-/g, '') || '';
        payload.abhaAddress = beneficiaryData?.abha_address;
        payload.isVerifiedInRCH2 = false;
        payload.abhaVerified = false;
      } else {
        let formattedExistingDob = beneficiaryData?.dob;
        if (beneficiaryData?.dob) {
          if (REGEX_PATTERNS.DATE_DD_MM_YYYY.test(beneficiaryData?.dob)) {
            const [day, month, year] = beneficiaryData.dob.split('-');
            formattedExistingDob = `${year}-${month}-${day}`;
          } else {
            const date = new Date(beneficiaryData.dob);
            if (!isNaN(date.getTime())) {
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const day = String(date.getDate()).padStart(2, '0');
              formattedExistingDob = `${year}-${month}-${day}`;
            }
          }
        }
        payload.beneficiaryName = beneficiaryData?.benf_name;
        payload.beneficiaryDob = formattedExistingDob;
        payload.abhaId = beneficiaryData?.abha_id?.replace(/-/g, '') || '';
        payload.abhaAddress = beneficiaryData?.abha_address;
        payload.isVerifiedInRCH2 = false;
        payload.abhaVerified = false;
      }

      const encodedPayload = encodeWithKeyAndShift(JSON.stringify(payload));
      await putDataJSON<any>(endpoints.updateBeneficiary, { data: encodedPayload });
      
      toast.success(`Face Auth Verified On ${dayjs().format(`${dateFormate.dd_mm_yyyy} ${dateFormate.hh_mm_A}`)}`, { position: 'top-center' });
      
      const response = await getData<any>(`${endpoints.getBeneficiaryById}/${id}`);
      if (response?.data && response.data.length > 0) {
        setBeneficiaryData(response.data[0]);
        dispatch(setBeneficiaryDetails(response.data));
      }
      
      sessionStorage.setItem("benfGridRender", "true");
    } catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error);
      toast.error('Failed to update beneficiary. Please try again.', { position: 'top-center' });
    }
  };

  const handleReAuthClick = () => {
    setIsReAuthFlow(true);
    if (beneficiaryData?.is_face_authenticated && beneficiaryData?.abha_id) {
      setShowReAuthModal(true);
    } else {
      dispatch(setBeneficiaryRedgOption(benef_const.verifyOptions.face_Authentication));
      dispatch(setBeneficiaryAuthType('Face_Auth_Creation'));
      dispatch(setBeneficiaryGender(beneficiaryData?.gender_name));
      setShowVerificationModal(true);
    }
  };

  const handleReAuthConfirm = () => {
    dispatch(setBeneficiaryRedgOption(benef_const.verifyOptions.face_Authentication));
    dispatch(setBeneficiaryAuthType('Face_Auth_Creation'));
    dispatch(setBeneficiaryGender(beneficiaryData?.gender_name));
    setShowVerificationModal(true);
  };

  const handleVerificationClose = (authType: string) => {
    setShowVerificationModal(false);
    if (authType === 'submit') {
      setShowFaceAuthModal(true);
    } else if (authType === 'back') {
      if (beneficiaryData?.is_face_authenticated && beneficiaryData?.abha_id) {
        setShowReAuthModal(true);
      } else {
        setIsReAuthFlow(false);
      }
    } else {
      setIsReAuthFlow(false);
    }
  };

  const handleFaceAuthModalClose = async (type: string, verifiedBeneficiaryData?: any) => {
    setShowFaceAuthModal(false);
    if (type === 'back') {
      setShowVerificationModal(true);
    } else if (type === 'submit') {
      
      if (isReAuthFlow && verifiedBeneficiaryData) {
        const comparison = compareData(beneficiaryData, verifiedBeneficiaryData);
        
        if (!comparison.abhaIdMatch) {
          toast.error('ABHA ID does not match. Re-authentication failed.', { position: 'top-center' });
          setIsReAuthFlow(false);
          setAbdmData(null);
          return;
        }
        
        if (comparison.allMatch) {
          await updateBeneficiaryWithFaceAuth(verifiedBeneficiaryData, false);
          setIsReAuthFlow(false);
          setAbdmData(null);
        } else {
          setAbdmData(verifiedBeneficiaryData);
          setShowComparisonModal(true);
        }
      } else {
        toast.success('Authentication completed successfully!', { position: 'top-center' });
        setIsReAuthFlow(false);
      }
    } else if (type === 'close') {
      setIsReAuthFlow(false);
    }
  };

  const handleComparisonModalClose = async (confirmed: boolean = false) => {
    setShowComparisonModal(false);
    
    if (confirmed && abdmData) {
      await updateBeneficiaryWithFaceAuth(abdmData, true);
    } else {
      toast.warning('Re-authentication cancelled.', { position: 'top-center' });
    }
    
    setIsReAuthFlow(false);
    setAbdmData(null);
  };


  return (
    <>{showUnauthorized?<Unauthorised/>:<div>
      <div className="overview_beneficiary">
        <BadgesComponent
          className="over-badge"
          badgeName="Personal Details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="overview-details">
          <div>
            <label className="overview-personal-details-label">Name</label>
            <div className="overview-personal-details-value">
              {beneficiaryData?.benf_name}
            </div>
          </div>
          <div>
            <label className="overview-personal-details-label">
              Spouse Name
            </label>
            <div className="overview-personal-details-value">
              {beneficiaryData?.spouse_name?beneficiaryData?.spouse_name:'-'}
            </div>
          </div>
          <div>
            <label className="overview-personal-details-label">Caste</label>
            <div className="overview-personal-details-value">
              {beneficiaryData?.category_name === 'ST'
                ? beneficiaryData?.is_pvtg_classified
                  ? 'ST- PVTG'
                  : 'ST'
                : beneficiaryData?.category_name}
            </div>
          </div>
          <div>
            <label className="overview-personal-details-label">
              Date of Birth
            </label>
            <div className="overview-personal-details-value">
              {new Date(beneficiaryData?.dob)
                .toLocaleDateString('en-GB')
                .slice(0, 8)
                .replace(/\//g, '-')
                .slice(0, 6) +
                new Date(beneficiaryData?.dob)
                  .getFullYear()
                  .toString()
                  .slice(-4)}
            </div>
          </div>
          <div>
            <label className="overview-personal-details-label">Religion</label>
            <div className="overview-personal-details-value">
              {beneficiaryData?.religion_name?beneficiaryData?.religion_name:'-'}
            </div>
          </div>
          <div>
            <label className="overview-personal-details-label">Others</label>
            <div className="overview-personal-details-value">
              {beneficiaryData?.other_religion?beneficiaryData?.other_religion:'-'}
            </div>
          </div>
          <div>
            <label className="overview-personal-details-label">
              Beneficiary Mobile Number
            </label>
            <div className="overview-personal-details-value">
              {beneficiaryData?.mob?beneficiaryData?.mob:'-'}
            </div>
          </div>
          <div>
            <label className="overview-personal-details-label">
              Alternate Mobile Number
            </label>
            <div className="overview-personal-details-value">
              {beneficiaryData?.alternate_mob?beneficiaryData?.alternate_mob:'-'}
            </div>
          </div>
          <div>
            <label className="overview-personal-details-label">
              ABHA Number
            </label>
            <div className="overview-personal-details-value">
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', flexWrap: 'nowrap' }}>
                <span style={{ whiteSpace: 'nowrap' }}>{beneficiaryData?.abha_id ? beneficiaryData?.abha_id : '-'}</span>
                {beneficiaryData?.abha_id && (
                  <>
                    {beneficiaryData?.is_face_authenticated && beneficiaryData?.face_authentication_date && (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="auth-info-tooltip">
                            <div style={{ 
                              textAlign: 'left', 
                              fontSize: '14px',
                              backgroundColor: '#f5f5f5', 
                              color: '#333',
                              borderBottom: '3px solid #d946a6',
                              borderRadius: '4px',
                              padding: '14px 18px',
                              margin: '-8px -12px',
                              minWidth: '340px'
                            }}>
                              <div style={{ marginBottom: '8px' }}><strong>Authenticated By:</strong> {(beneficiaryData?.face_authenticated_f_name || beneficiaryData?.face_authenticated_l_name) ? `${beneficiaryData?.face_authenticated_f_name || ''}${beneficiaryData?.face_authenticated_l_name ? ` ${beneficiaryData?.face_authenticated_l_name}` : ''}`.trim() : 'N/A'}</div>
                              <div><strong>Authentication Date:</strong> {dayjs(beneficiaryData?.face_authentication_date).format(`${dateFormate.dd_mm_yyyy} ${dateFormate.hh_mm_A}`)}</div>
                            </div>
                          </Tooltip>
                        }
                      >
                        <i className="bi bi-info-circle-fill" style={{ cursor: 'pointer', color: '#0066cc', fontSize: '16px', flexShrink: 0 }}></i>
                      </OverlayTrigger>
                    )}
                    <div className={beneficiaryData?.abha_id ? 'verified' : 'not-verified'} style={{ whiteSpace: 'nowrap' }}>
                      {beneficiaryData?.is_face_authenticated ? 'Authenticated' : 'Verified'}
                    </div>
                  </>
                )}
                {!beneficiaryData?.abha_id && (
                  <div className="not-verified">Not Verified</div>
                )}
              </div>
              {beneficiaryData?.abha_id && config.showFaceAuth === "ON" && (
                <Button
                  onClick={handleReAuthClick}
                  buttonName={buttonNames.reAuth}
                  colorType="primary"
                  id="re-authenticate-abha"
                  icon={''}
                  iconPosition="left"
                />
              )}
            </div>
          </div>
          <div>
            <label className="overview-personal-details-label">
              ABHA Address
            </label>
            <div className="overview-personal-details-value">
              {beneficiaryData?.abha_address ?? '-'}
            </div>
          </div>
          {beneficiaryData?.gender_name===gender.female && <div>
            <label className="overview-personal-details-label">
              Completed weeks of pregnancy
            </label>
            <div className="overview-personal-details-value">
              {completedWeeksPregnancy?completedWeeksPregnancy:'-'}
            </div>
          </div>}
          
          <CheckboxComponent
            className="cb-overview-report"
            checkBoxName="Enroll for SMS"
            disabled={true}
            onCheckboxChange={() => { }}
            placeCheckboxBefore={false}
            isChecked={beneficiaryData?.enroll_for_sms}
          />
          <div>
            <label className="overview-personal-details-label">
              Registration Date
            </label>
            <div className="overview-personal-details-value">
              {beneficiaryData?.benef_reg_dt?desiredFormatDate(beneficiaryData?.benef_reg_dt,dateFormate.dd_mm_yyyy):'-'}
            </div>
          </div>
          <div>
            <label className="overview-personal-details-label">
              Village
            </label>
            <div className="overview-personal-details-value">
              {beneficiaryData?.village_name?beneficiaryData?.village_name:'-'}
            </div>
          </div>
          <div>
            <label className="overview-personal-details-label">
              Ward
            </label>
            <div className="overview-personal-details-value">
              {beneficiaryData?.ward_name?beneficiaryData?.ward_name:'-'}
            </div>
          </div>
        </div>
      </div>
      {historyData?.length !== 0 && <div className="overview_beneficiary">
        <BadgesComponent
          className="over-badge"
          badgeName="Obstetric History"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="beneficiary_overview_healthProvider">
          {historyData?.slice()?.reverse()?.map((pregnancy: any, index: any) => (
            <div className="beneficiary_overview_marginTop" key={pregnancy.pregnancy_id}>
              <label className="overview-personal-details-label">
                {`Obstetric History ${index + 1}`}
              </label>
              <div className="overview-personal-details-value">
                {pregnancy.obstetric_history
                  .map((item:any) => item.obstetric_history_name?item.obstetric_history_name:'-').join(", ")}
              </div>
            </div>
          ))}
        </div>
      </div>}
      <div className="beneficiary_overview_facility">
        <div className='beneficiary_overview_flex'>
          <BadgesComponent
            className="over-badge"
            badgeName="Service Providers"
            variant="primary-1"
            badgeType="case5"
          />
          <div className="beneficiary_overview_healthProvider">
            <div>
              <label className="overview-personal-details-label">
                Health Provider Name
              </label>
              <div className="overview-personal-details-value">
                {
                Array.isArray(beneficiaryData?.health_provider_name) &&
                beneficiaryData?.health_provider_name.some((name:any) => name != null && name !== '')
                ? beneficiaryData?.health_provider_name.join(',')
                : '-'
              }
              </div>
            </div>
            <div>
              <label className="overview-personal-details-label">
                Asha/ Mobiliser Name
              </label>
              <div className="overview-personal-details-value">
                {beneficiaryData?.mobiliser_f_name ? beneficiaryData?.mobiliser_f_name : '-'}
              </div>
            </div>
          </div>
        </div>
        <span className="beneficiary_overview_line"></span>
        <div className='beneficiary_overview_flex'>
          <BadgesComponent
            className="over-badge"
            badgeName="Facility Details"
            variant="primary-1"
            badgeType="case5"
          />
          <div className="beneficiary_overview_healthProvider">
            <div>
              <label className="overview-personal-details-label">
                Facility Type
              </label>
              <div className="overview-personal-details-value">
              {
                Array.isArray(beneficiaryData?.facility_type) &&
                beneficiaryData?.facility_type.some((type:any) => type != null && type !== '')
                ? beneficiaryData?.facility_type.join(',')
                : '-'
              }
              </div>
            </div>
            <div>
              <label className="overview-personal-details-label">
                Facility Name
              </label>
              <div className="overview-personal-details-value">
              {
                Array.isArray(beneficiaryData?.facility_name) &&
                beneficiaryData?.facility_name.some((name:any) => name != null && name !== '')
                ? beneficiaryData?.facility_name.join(',')
                : '-'
              }
              </div>
            </div>
          </div>
        </div>
      </div>
      {benefDeathDetails?.[0]?.is_dead ? (<div className="beneficiay_death_details">
        <BadgesComponent
          className="over-badge"
          badgeName="Death Details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="death_details">
          <div>
            <label className="beneficiay_death_details_label">Date of Death</label>
            <div className="beneficiay_death_details_value">
              {dayjs(benefDeathDetails?.[0]?.date_of_death).format("DD-MM-YYYY")}
            </div>
          </div>
          <div>
            <label className="beneficiay_death_details_label">Place of Death</label>
            <div className="beneficiay_death_details_value">
              {benefDeathDetails?.[0]?.place_of_death_name}
            </div>
          </div>
          <div>
            <label className="beneficiay_death_details_label">Probable cause of Death</label>
            <div className="beneficiay_death_details_value">
              {benefDeathDetails?.[0]?.probable_cause_of_death_name}
            </div>
          </div>
          <div>
            <label className="beneficiay_death_details_label">Notification sent by ASHA within 24Hrs</label>
            <div className="beneficiay_death_details_value">
              {benefDeathDetails?.[0]?.notification_sent_by_asha_with_24hrs === true ? "Yes" : "No"}
            </div>
          </div>
          <div>
            <label className="beneficiay_death_details_label">FBIR completed by ANM</label>
            <div className="beneficiay_death_details_value">
              {benefDeathDetails?.[0]?.fbir_completed_by_anm === true ? "Yes" : "No"}
            </div>
          </div>
          <div>
            <label className="beneficiay_death_details_label">Death Happened During</label>
            <div className="beneficiay_death_details_value">
              {benefDeathDetails?.[0]?.benef_death_name ? benefDeathDetails?.[0]?.benef_death_name : '-'}
            </div>
          </div>
        </div>
      </div>) : ''}
      </div>}
      <ReAuthenticateConfirmationModal
        showModal={showReAuthModal}
        setShowModal={setShowReAuthModal}
        onConfirm={handleReAuthConfirm}
        authenticationDate={beneficiaryData?.face_authentication_date}
        authenticatedBy={beneficiaryData?.face_authenticated_by}
      />
      <VerificationModal
        showModal={showVerificationModal}
        handleClose={handleVerificationClose}
        setLinkedBenefDetails={setLinkedBenefDetails}
      />
      <FaceAuthenticationModal
        showModal={showFaceAuthModal}
        handleClose={handleFaceAuthModalClose}
      />
      <ReAuthenticationModal
        showModal={showComparisonModal}
        handleClose={handleComparisonModalClose}
        beneficiaryData={beneficiaryData}
        abdmData={abdmData}
      />
    </>
  );
};
 
export default BeneficiaryView;